module.exports = __webpack_public_path__ + "static/media/Logo.bc16ceea.svg";